import React from "react";
import Typewriter from "typewriter-effect";

function Home3() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Engineer",
          "Front-end Developer",
          "Back-end Developer",
          "Full-Stack Developer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 90,
      }}
    />
  );
}

export default Home3;
